import React, { useEffect } from 'react';
import { 
  Heart, 
  ShieldCheck, 
  CheckCircle2, 
  Building2, 
  Stethoscope 
} from 'lucide-react';
import Navbar from '../Navbar/Navbar';
import FooterSection from '../FooterSection/FooterSection';
import QuickAccess from '../QuickAccess/QuickAccess';
import './AboutPage.css';
import DoctorName from '../DoctorName/DoctorName';
import mahmutaluc from '../../assets/mahmutaluc.jpeg'
const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">
      <Navbar />

      {/* 1. HERO */}
      <section className="about-hero">
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="hero-content">
            <span className="hero-badge">HAKKIMDA & FELSEFEM</span>
            <h1><DoctorName/></h1>
            <p>“Çocuklar, yetişkinlerin küçültülmüş bir kopyası değildir.”</p>
          </div>
        </div>
      </section>

      {/* 2. BİYO - Hocanın Kendi Ağzından Özgeçmiş */}
      <section className="about-bio section-padding">
        <div className="container bio-grid">
          <div className="bio-visual">
            <div className="bio-image-frame">
              <img 
                src={mahmutaluc} 
                alt="Dr. Mahmut Aluç" 
                className="main-doctor-img"
              />
              <div className="experience-sticker">
                <strong>30+</strong>
                <span>Yıllık Birikim</span>
              </div>
            </div>
          </div>
          <div className="bio-info">
            <h2>Özgeçmişim</h2>
            <p>
              1992 yılında <strong>Cumhuriyet Üniversitesi Tıp Fakültesi</strong>'nden mezun olarak bu onurlu mesleğe adım attım. 
              İhtisasımı <strong>Çukurova Üniversitesi Çocuk Cerrahisi Ana Bilim Dalı</strong>'nda tamamladım.
            </p>

            {/* ÇALIŞILAN HASTANELER LİSTESİ - DOKÜMANDAKİ GİBİ SADE */}
            <div className="hospitals-list-container">
              <h3 className="h-list-title">Çalıştığım Hastaneler:</h3>
              <ul className="h-list-content">
                <li><Building2 size={18} className="h-dot-icon" /> Sivas SSK Hastanesi</li>
                <li><Building2 size={18} className="h-dot-icon" /> Sivas Devlet Hastanesi</li>
                <li><Building2 size={18} className="h-dot-icon" /> Sivas Numune Hastanesi</li>
                <li><Building2 size={18} className="h-dot-icon" /> Sivas MEDICANA Hastanesi</li>
              </ul>
            </div>

            <div className="bio-check-list">
              <div className="check-item"><CheckCircle2 className="c-icon" /> <span>Hassas Yenidoğan Cerrahisi</span></div>
              <div className="check-item"><CheckCircle2 className="c-icon" /> <span>Gelecek Odaklı Cerrahi Müdahale</span></div>
            </div>
          </div>
        </div>
      </section>

     

      <FooterSection />
      <QuickAccess />
    </div>
  );
};

export default AboutPage;